// == Unichat Extension ==
// Versão exibida na tela vazia de conversas. Atualizar a cada deploy junto
// com a tag da imagem Docker (não é a versão do Chatwoot núcleo).
export const UNICHAT_VERSION = 'v20.1.11';
